/** Composante ServiceBoxHeight */
export default class ServiceBoxHeight {
  /**
   * Méthode constructeur
   * @param {HTMLElement} element - Élément HTML sur lequel la composante est instanciée
   */
  constructor(element) {
    this.element = element;
    this.resizeTimer = null;

    this.init();
  }

  init() {
    // S'assurer que le DOM est prêt avant d'exécuter
    const runAdjust = () => {
      this.adjust();

      // Réajuster sur resize avec debounce
      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          this.adjust();
        }, 250);
      });

      // Observer les changements de taille dans les .text-container (images / contenu dynamique)
      if (window.ResizeObserver) {
        this.ro = new ResizeObserver(() => {
          this.adjust();
        });

        // observer chaque .text-container et les images à l'intérieur
        const boxes = (this.element || document).querySelectorAll(
          '.service-box'
        );
        boxes.forEach((box) => {
          const textContainer = box.querySelector('.text-container');
          if (textContainer) this.ro.observe(textContainer);
          const imgs = box.querySelectorAll('img');
          imgs.forEach((img) => this.ro.observe(img));
        });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runAdjust);
      // aussi déclencher sur load pour être sûr que les images sont chargées
      window.addEventListener('load', runAdjust);
    } else {
      runAdjust();
    }
  }

  adjust() {
    const scope = this.element || document;
    const rows = scope.querySelectorAll('.row');

    rows.forEach((row, rowIndex) => {
      const serviceBoxes = row.querySelectorAll('.service-box');
      if (!serviceBoxes.length) return;

      serviceBoxes.forEach((box) => {
        const textContainer = box.querySelector('.text-container');
        if (textContainer) {
          textContainer.style.height = '';
        }
      });

      let maxHeight = 0;
      serviceBoxes.forEach((box, boxIndex) => {
        const textContainer = box.querySelector('.text-container');
        if (textContainer) {
          const height = Math.ceil(textContainer.scrollHeight);
          maxHeight = Math.max(maxHeight, height);
        }
      });

      if (maxHeight > 0) {
        serviceBoxes.forEach((box) => {
          const textContainer = box.querySelector('.text-container');
          if (textContainer) {
            textContainer.style.height = `${maxHeight}px`;
          }
        });
      }
    });
  }
}
